import {__} from "./libraries/translations.ts";

require('./google-places-search.js');

const {ActivityController} = require('./controllers/activity-controller.ts');
const moment = require('moment');

$(document).ready(_ => {

    const searchForm = $('#activities-search-form');
    const aContainer = $('#activities-container');
    const AC = new ActivityController(
        aContainer,
        searchForm,
        $('#pagination-options'),
        $('#paginator-container'),
        null,
        {},
        $('#activities-map')[0]
    );
    AC.find();

    if(aContainer.hasClass('reload-on-favorite')) {
        AC.onFavoriteClicked(() => {
            location.reload();
        });
    }

    ////// DATE RANGE PICKER


    $('.date-find').each((index, element) => {
        const locale = __('daterangepicker');

        const ranges = {};
        ranges[locale.ranges['today']] = [moment(), moment()];
        ranges[locale.ranges['tomorrow']] = [moment().add(1, 'days'), moment().add(1, 'days')];
        ranges[locale.ranges['day-after-tomorrow']] = [moment().add(2, 'days'), moment().add(2, 'days')];
        ranges[locale.ranges['next-7-days']] = [moment(), moment().add(6, 'days')];
        ranges[locale.ranges['next-30-days']] = [moment(), moment().add(29, 'days')];
        ranges[locale.ranges['clear']] = ['', ''];

        $(element).daterangepicker({
            autoApply: true,
            autoUpdateInput: false,
            minDate: parseInt(moment().format(__('daterangepicker.format')), 10),
            maxDate: parseInt(moment().add(5, 'years').format(__('daterangepicker.format')), 10),
            locale: locale,
            showCustomRangeLabel:true,
            ranges: ranges
        });
    });/**/
    $('.date-find').on('apply.daterangepicker', function(ev, picker) {
        if( ! picker.startDate instanceof Date || isNaN(picker.startDate)  ){
          $(this).addClass('text-hidden');
          picker.startDate = moment();
          picker.endDate = moment().add(5, 'years');
        }else{
          $(this).removeClass('text-hidden');
        }
        $(this).val(picker.startDate.format(__('daterangepicker.format')) + ' - ' + picker.endDate.format(__('daterangepicker.format')));

    });

    $('.date-find').on('cancel.daterangepicker', function(ev, picker) {
        $(this).val('');
    });


});

 /**/
